export default __webpack_public_path__ + "static/media/total-stake-stake.7f68feff.png";